import type { DeepReadonly } from "@itandi/itandi-bb-ui";
import { InputSelect } from "@itandi/itandi-bb-ui";
import type React from "react";
import { useFormContext } from "react-hook-form";
import type {
	NotificationEdit,
	NotificationTargetType,
	TriggerType
} from "~/models/Notification";
import {
	COMPANY_TRIGGER_TYPE_SELECT_OPTIONS,
	ONLY_IMMEDIATE_TRIGGER_TYPE,
	ONLY_ORIGIN_VENDOR_TRIGGER_TYPE,
	ONLY_SUB_VENDOR_TRIGGER_TYPE,
	VENDOR_TRIGGER_TYPE_SELECT_OPTIONS
} from "~/models/Notification";
import Styles from "../NotificationModal.module.scss";

type Props = DeepReadonly<{
	type: NotificationTargetType;
}>;

export const TriggerTypeSelect: React.FC<Props> = ({ type }) => {
	const { register, formState, setValue } = useFormContext<NotificationEdit>();
	const { errors } = formState;
	const handleChange = (e: React.ChangeEvent<HTMLSelectElement>): void => {
		const triggerType = e.target.value as TriggerType;

		if (ONLY_IMMEDIATE_TRIGGER_TYPE.includes(triggerType)) {
			setValue("notifyType", "immediate");
		}
		if (ONLY_ORIGIN_VENDOR_TRIGGER_TYPE.includes(triggerType)) {
			setValue("receiveType", "origin_deal_vendor_company");
		} else if (ONLY_SUB_VENDOR_TRIGGER_TYPE.includes(triggerType)) {
			setValue("receiveType", "sub_deal_vendor_company");
		}

		setValue("triggerType", triggerType);
	};
	return (
		<>
			<div>
				<InputSelect
					isInvalid={errors.triggerType != null}
					{...register("triggerType")}
					onChange={handleChange}
				>
					<option value="">選択なし</option>
					{type === "CompanyNotification" && (
						<>
							{COMPANY_TRIGGER_TYPE_SELECT_OPTIONS.map((opt) => (
								<option key={opt.value} value={opt.value}>
									{opt.label}
								</option>
							))}
						</>
					)}
					{type === "VendorNotification" && (
						<>
							{VENDOR_TRIGGER_TYPE_SELECT_OPTIONS.map((opt) => (
								<option key={opt.value} value={opt.value}>
									{opt.label}
								</option>
							))}
						</>
					)}
				</InputSelect>
			</div>
			{errors.triggerType != null && (
				<div className={Styles.InvalidFeedback}>
					{errors.triggerType.message}
				</div>
			)}
		</>
	);
};
